import React, {Component} from 'react';
import BarTitle from "../../../components/BarTitle/index";
import Painel from "../../../components/Painel/index";
import constants from '../../../constants';
import axios from 'axios';

const removeDots = str => str.replace(/\./g, "");

class CancelPurchase extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);

        this.state = {
            httpStatus: 0,
            message: ''
        };
    }

    onAmountChange(event) {
        let val = removeDots(event.target.value);
        event.target.value = val.replace(/\d{2}$/, e => "." + e);
    }

    handleSubmit(event) {
        event.preventDefault();
        const name = this.refs.locator.value;
        const value = removeDots(this.refs.value.value);

        const cancelPurchase = constants().URL_SERVICE + 'cancelPurchase';

        axios.post(cancelPurchase, {
                name, value
            }, {headers: {'token': localStorage.token}}
        ).then((response) => {

            if (response.data.httpStatus === 400) {
                this.setState({
                    message: response.data.message,
                    httpStatus: 400,
                });
            }
            if (response.data.httpStatus === 200) {
                this.setState({
                    message: response.data.message,
                    httpStatus: 200,
                });
            }
        });

    };

    render() {
        let resultCielo = "";

        if (this.state.httpStatus !== 0 && this.state.httpStatus === 400) {
            resultCielo = <div>
                <h4>Resultado transação:</h4>
                <span className="label label-danger h2">Erro no estorno</span>
                <h5>Mensagem Cielo: {this.state.message} </h5>
            </div>;
        }

        if (this.state.httpStatus !== 0 && this.state.httpStatus === 200) {
            resultCielo = <div>
                <h4>Resultado transação:</h4>
                <span className="label label-success h2">Operacao realizada com sucesso</span>
                <h5>Mensagem Cielo: {this.state.message} </h5>
            </div>;
        }

        return (
            <div>
                <BarTitle name="Estornar"/>
                <div className="wrapper-md">

                    <Painel title="Dados do Estorno">
                        <fieldset>
                            <div className="row">
                                <div className="col-md-6">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="control-group">
                                            <label label-default="" className="control-label">Localizador</label>
                                            <div className="controls">
                                                <input type="text" required className="form-control" ref="locator"/>
                                            </div>
                                        </div>
                                        <div className="control-group">
                                            <label label-default="" className="control-label">Valor</label>
                                            <div className="controls">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <input type="text" className="form-control" autocomplete="off"
                                                               maxlength="4"
                                                               title="First four digits" onChange={this.onAmountChange}
                                                               required ref="value"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="control-group">
                                            <div className="controls">
                                                <div className="row">

                                                    <div className="col-md-8"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="control-group">
                                            <label label-default="" className="control-label"></label>
                                            <div className="controls">
                                                <button type="submit" className="btn btn-primary">Enviar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-6">
                                    {resultCielo}
                                </div>
                            </div>

                        </fieldset>
                    </Painel>
                </div>
            </div>
        );
    }
}

export default CancelPurchase;



// WEBPACK FOOTER //
// ./src/views/Cielo/cancelPurchase/index.js